/* Elna Service — filter the product gallery by the selected colour.

   Why this exists: a Shopify variant can hold only ONE media item, so the
   platform cannot give each colour its own gallery. Every photo therefore
   lives on the product, tagged by colour in its alt text, and this script
   shows only the ones matching the colour the customer picked.

   Alt text is matched loosely so legacy English alts ("Fluger 4 Black")
   still resolve to the Romanian option value ("Negru").

   Longest aliases are tested first so "Gold periat" never matches as "Gold".
*/
(function () {
  'use strict';

  var COLOURS = [
    { value: 'Gold periat', aliases: ['gold periat', 'gold brushed', 'szczotkowane', 'brushed', 'satin'] },
    { value: 'Gold lucios', aliases: ['gold lucios', 'gold polysk', 'polysk', 'lucios'] },
    { value: 'Negru',       aliases: ['negru', 'black'] },
    { value: 'Alb',         aliases: ['alb', 'white'] },
    { value: 'Crom',        aliases: ['crom', 'chrome', 'chrom'] },
    { value: 'Gold',        aliases: ['gold', 'auriu'] }
  ];

  function selectedColour() {
    var input = document.querySelector(
      'variant-picker input[type="radio"]:checked[data-option-name="Culoare"]'
    );
    if (input) return (input.value || '').trim();

    var sel = document.querySelector('variant-picker select');
    if (sel && /culoare/i.test(sel.name || '')) return (sel.value || '').trim();

    return null;
  }

  /* Which colour, if any, does this alt text belong to? null = shared shot. */
  function colourOfAlt(alt) {
    if (!alt) return null;
    var a = alt.toLowerCase();
    for (var i = 0; i < COLOURS.length; i++) {
      var c = COLOURS[i];
      for (var j = 0; j < c.aliases.length; j++) {
        if (a.indexOf(c.aliases[j]) !== -1) return c.value;
      }
    }
    return null;
  }

  function galleryItems() {
    return document.querySelectorAll(
      'media-gallery .media-gallery__grid > li, media-gallery slideshow-slide'
    );
  }

  var running = false;

  function apply() {
    if (running) return;
    running = true;

    try {
      var selected = selectedColour();
      var items = galleryItems();
      if (!selected || !items.length) return;

      var shown = 0;

      items.forEach(function (el) {
        var img = el.querySelector('img');
        var colour = colourOfAlt(img ? img.getAttribute('alt') : '');
        var hide = colour !== null && colour !== selected;

        el.toggleAttribute('data-elna-hidden', hide);
        el.style.display = hide ? 'none' : '';
        if (!hide) shown++;
      });

      /* Never leave an empty gallery: if the tagging is wrong for this
         product, put everything back rather than showing a blank column. */
      if (shown === 0) {
        items.forEach(function (el) {
          el.removeAttribute('data-elna-hidden');
          el.style.display = '';
        });
      }
    } finally {
      running = false;
    }
  }

  var queued = null;
  function schedule() {
    clearTimeout(queued);
    queued = setTimeout(apply, 60);
  }

  function init() {
    if (!document.querySelector('media-gallery')) return;

    apply();

    /* Customer picks a colour */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.matches('variant-picker input[type="radio"], variant-picker select')) schedule();
    });

    /* The theme re-renders the gallery over the network after a variant
       change, which replaces our nodes — re-apply once that settles. */
    var gallery = document.querySelector('media-gallery');
    if (gallery && window.MutationObserver) {
      new MutationObserver(schedule).observe(gallery, { childList: true, subtree: true });
    }

    document.addEventListener('variant:update', schedule);
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
